// src/components/layout/MenuItem.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";

const MenuItem = ({ item, level = 0 }) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const hasSubItems = item.sub_menu_items && item.sub_menu_items.length > 0;

  const handleMouseEnter = () => {
    if (hasSubItems) setIsSubMenuOpen(true);
  };
  const handleMouseLeave = () => {
    if (hasSubItems) setIsSubMenuOpen(false);
  };

  // --- (level 0) ---
  const topLevelBaseClass =
    "px-3 lg:px-4 py-2 text-base lg:text-xl flex items-center transition-colors duration-150 ease-in-out";
  const topLevelTextColor = "text-gray-700 hover:text-blue-500";
  const topLevelLinkClass = `${topLevelBaseClass} ${topLevelTextColor}`;
  const topLevelButtonClass = `${topLevelBaseClass} ${topLevelTextColor} focus:outline-none`;

  // --- (level > 0) ---
  const subMenuBgColor = "bg-gray-100";
  const subMenuItemBaseClass = `block w-full text-left px-4 py-3 text-lg flex items-center justify-between transition-colors duration-150 ease-in-out text-gray-700 hover:bg-gray-200`;
  const subMenuContainerBaseClass = `absolute w-max min-w-[200px] ${subMenuBgColor} shadow-xl z-40 rounded-sm`;

  if (level === 0) {
    return (
      <li
        className="relative"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {item.url ? (
          <Link to={item.url} className={topLevelLinkClass}>
            <span className="font-medium">{item.title}</span>{" "}
            {hasSubItems && (
              <svg
                className="ml-1.5 h-4 w-4 text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </Link>
        ) : (
          <button type="button" className={topLevelButtonClass}>
            <span className="font-medium">{item.title}</span>
            {hasSubItems && (
              <svg
                className="ml-1.5 h-4 w-4 text-gray-500"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>
        )}
        {hasSubItems && isSubMenuOpen && (
          <ul className={`${subMenuContainerBaseClass} left-0 mt-0 shadow-lg`}>
            {item.sub_menu_items.map((subItem) => (
              <MenuItem
                key={subItem.id || subItem.title}
                item={subItem}
                level={level + 1}
              />
            ))}
          </ul>
        )}
      </li>
    );
  } else {
    return (
      <li
        className="relative group"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {item.url ? (
          <Link to={item.url} className={subMenuItemBaseClass}>
            <span>{item.title}</span>
            {hasSubItems && (
              <svg
                className="ml-auto h-4 w-4 text-gray-300"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </Link>
        ) : (
          <button type="button" className={subMenuItemBaseClass}>
            <span>{item.title}</span>
            {hasSubItems && (
              <svg
                className="ml-auto h-4 w-4 text-gray-300"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>
        )}
        {hasSubItems && isSubMenuOpen && (
          <ul
            className={`${subMenuContainerBaseClass} left-full top-0 -mt-px ml-[1px]`}
          >
            {item.sub_menu_items.map((subItem) => (
              <MenuItem
                key={subItem.id || subItem.title}
                item={subItem}
                level={level + 1}
              />
            ))}
          </ul>
        )}
      </li>
    );
  }
};
export default MenuItem;
